import { Component, OnInit, ViewChild, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { DeepLinkUtil } from '../../../core/utils/deep-link.util';

@Component({
  selector: 'app-mock-interviews',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mock-interviews.component.html',
  styleUrls: ['./mock-interviews.component.scss']
})
export class MockInterviewsComponent implements OnInit {
  @ViewChild('mockGrid') mockGrid!: ElementRef;
  isAtStart = true;
  isAtEnd = false;
  interviews: any[] = [];
  loading = true;

  isBrowser: boolean = true;
  constructor(private http: HttpClient, private router: Router, @Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.fetchPublishedInterviews();
  }

  fetchPublishedInterviews(): void {
    const url = environment.hrmsApiUrl + '/rounds?is_public=true&publish_status=Published&limit=12';
    this.http.get<any>(url).subscribe({
      next: (res) => {
        const dataObj = res?.Data || res?.data;
        if (dataObj && dataObj.rounds) {
          this.interviews = dataObj.rounds;
        }
        this.loading = false;
        setTimeout(() => this.checkScrollPosition(), 100);
      },
      error: (err) => {
        console.error('Failed to fetch mock interviews', err);
        this.loading = false;
        setTimeout(() => this.checkScrollPosition(), 100);
      }
    });
  }


  onViewAll(): void {
    const token = localStorage.getItem('token');
    if (token) {
      this.router.navigate(['/student-dashboard/ai-interview-dashboard']);
    } else {
      this.router.navigate(['/mock-interview']);
    }
  }

  onStartInterview(roundId: string): void {
    // Deep Linking: Try to launch the Android app into the interview dashboard
    // rather than using web routing for mobile users.
    if (DeepLinkUtil.isAndroid()) {
        window.location.href = DeepLinkUtil.getAndroidIntentUrl('student-dashboard/ai-interview-dashboard');
        return;
    }
    const userToken = localStorage.getItem('token');
    if (!userToken) {
      localStorage.setItem('pending_practice_round_id', roundId);
      this.router.navigate(['/login'], { queryParams: { redirectUrl: '/student-dashboard/ai-interview-dashboard' } });
    } else {
      const interview = this.interviews.find(i => i.id === roundId || i._id === roundId || i.screening_round_id === roundId);
      
      let token = interview?.unique_token;
      if (!token && interview?.interview_url) {
        const parts = interview.interview_url.split('/');
        if (parts.length >= 2) {
          token = parts[parts.length - 2];
        }
      }
      
      if (token) {
        const urlTree = this.router.createUrlTree(['/interview.ai', token, roundId], { queryParams: { is_b2c_practice: 'true' } });
        const url = this.router.serializeUrl(urlTree);
        window.open(url, '_blank');
      } else {
        // Fallback if unique_token not found in the list
        this.router.navigate(['/student-dashboard/ai-interview-dashboard']);
      }
    }
  }
  getCardScrollAmount(): number {
    if (!this.mockGrid?.nativeElement || !this.isBrowser) return 300;
    const cards = this.mockGrid.nativeElement.querySelectorAll('.mock-card');
    if (cards.length >= 2) {
      const diff = cards[1].offsetLeft - cards[0].offsetLeft;
      return diff > 0 ? diff : 300;
    }
    return 300;
  }

  scrollLeft(): void {
    if (!this.mockGrid?.nativeElement || !this.isBrowser) return;
    const scrollAmount = this.getCardScrollAmount();
    this.mockGrid.nativeElement.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    setTimeout(() => this.checkScrollPosition(), 400);
  }

  scrollRight(): void {
    if (!this.mockGrid?.nativeElement || !this.isBrowser) return;
    const scrollAmount = this.getCardScrollAmount();
    this.mockGrid.nativeElement.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    setTimeout(() => this.checkScrollPosition(), 400);
  }

  private scrollTimeout: any = null;
  onGridScroll(): void {
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.checkScrollPosition();
      this.scrollTimeout = null;
    }, 150);
  }

  checkScrollPosition(): void {
    if (!this.mockGrid?.nativeElement || !this.isBrowser) return;
    const el = this.mockGrid.nativeElement;
    
    this.isAtStart = el.scrollLeft <= 5;
    
    const maxScroll = el.scrollWidth - el.clientWidth;
    this.isAtEnd = maxScroll <= 0 || el.scrollLeft >= maxScroll - 5;
  }
}
